import { useShortIdContext } from '@air/provider-short-id';

import { useCanShowNestedItemsChip } from '~/components/v2/components/shared/gallery/useCanShowNestedItemsChip';
import { useGalleryNestedHeaderControls } from '~/components/v2/components/shared/gallery/useGalleryNestedHeaderControls';

export type UsePublicShowcaseGalleryNestedControlsParams = {
  /** Listing blocks pass false for every gallery except the one that should hold the chip. */
  isNestedChipHost: boolean;
};

/** Nested controls for a showcase page. A drilled board uses the board hook instead. */
export const usePublicShowcaseGalleryNestedControls = ({
  isNestedChipHost,
}: UsePublicShowcaseGalleryNestedControlsParams) => {
  const { presentationSettings } = useShortIdContext();
  const isExpandNestedDisabled = Boolean(presentationSettings?.lockedControls?.expandNested);
  const { canShowNestedItemsChip } = useCanShowNestedItemsChip({
    isDisabled: isExpandNestedDisabled,
  });

  return useGalleryNestedHeaderControls({
    canShowNestedItemsChip,
    isDisabled: isExpandNestedDisabled,
    isNestedChipHost,
  });
};
